import React, { useState } from 'react';
import { TagIcon, TruckIcon } from 'lucide-react';
import { useCart } from '../../context/CartContext';
import { formatPrice } from '../../utils/formatters';
import { Input } from '../ui/Input';
import { Button } from '../ui/Button';
interface CartSummaryProps {
  onCheckout?: () => void;
}
export function CartSummary({
  onCheckout
}: CartSummaryProps) {
  const {
    subtotal,
    shippingCost,
    total,
    itemCount
  } = useCart();
  const [couponCode, setCouponCode] = useState('');
  const [couponError, setCouponError] = useState('');
  const [discount, setDiscount] = useState(0);
  const handleApplyCoupon = () => {
    if (couponCode.toUpperCase() === 'SAVE10') {
      setDiscount(subtotal * 0.1);
      setCouponError('');
    } else {
      setCouponError('Invalid coupon code');
      setDiscount(0);
    }
  };
  const finalTotal = total - discount;
  return <div className="bg-white rounded-xl border border-gray-100 shadow-card p-6" data-id="element-60">
      <h2 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-61">
        Order Summary
      </h2>

      <div className="space-y-3 text-sm" data-id="element-62">
        <div className="flex justify-between" data-id="element-63">
          <span className="text-gray-600" data-id="element-64">Subtotal ({itemCount} items)</span>
          <span className="font-medium text-gray-900" data-id="element-65">
            {formatPrice(subtotal)}
          </span>
        </div>

        <div className="flex justify-between" data-id="element-66">
          <span className="text-gray-600 flex items-center gap-1" data-id="element-67">
            <TruckIcon className="w-4 h-4" data-id="element-68" />
            Shipping
          </span>
          <span className="font-medium text-gray-900" data-id="element-69">
            {shippingCost === 0 ? <span className="text-green-600" data-id="element-70">Free</span> : formatPrice(shippingCost)}
          </span>
        </div>

        {discount > 0 && <div className="flex justify-between text-green-600" data-id="element-71">
            <span className="flex items-center gap-1" data-id="element-72">
              <TagIcon className="w-4 h-4" data-id="element-73" />
              Discount
            </span>
            <span className="font-medium" data-id="element-74">-{formatPrice(discount)}</span>
          </div>}
      </div>

      {/* Coupon code */}
      <div className="mt-4 pt-4 border-t border-gray-100" data-id="element-75">
        <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-76">
          Have a coupon code?
        </label>
        <div className="flex gap-2" data-id="element-77">
          <Input type="text" placeholder="Enter code" value={couponCode} onChange={e => setCouponCode(e.target.value)} error={couponError} className="flex-1" data-id="element-78" />
          <Button variant="outline" onClick={handleApplyCoupon} data-id="element-79">
            Apply
          </Button>
        </div>
        <p className="text-xs text-gray-500 mt-2" data-id="element-80">Try: SAVE10 for 10% off</p>
      </div>

      {/* Total */}
      <div className="mt-4 pt-4 border-t border-gray-100" data-id="element-81">
        <div className="flex justify-between items-center" data-id="element-82">
          <span className="text-lg font-semibold text-gray-900" data-id="element-83">Total</span>
          <span className="text-2xl font-bold text-gray-900" data-id="element-84">
            {formatPrice(finalTotal)}
          </span>
        </div>
        <p className="text-xs text-gray-500 mt-1" data-id="element-85">Including all taxes</p>
      </div>

      {/* Checkout button */}
      <Button variant="primary" size="lg" fullWidth className="mt-6" onClick={onCheckout} disabled={itemCount === 0} data-id="element-86">
        Proceed to Checkout
      </Button>

      {/* Free shipping notice */}
      {shippingCost > 0 && <div className="mt-4 p-3 bg-primary-50 rounded-lg" data-id="element-87">
          <p className="text-sm text-primary-700" data-id="element-88">
            Add {formatPrice(5000 - subtotal)} more to get{' '}
            <strong data-id="element-89">FREE shipping!</strong>
          </p>
        </div>}
    </div>;
}